// react components
import React from 'react'
import {
    Dialog,
} from '@mui/material'
import {
    useDispatch,
    useSelector,
} from 'react-redux'

// data
import {
    defaultReduxState,
    reduxModalMainFormHideSite,
} from 'data'

// pages
import {
    FormModal825,
} from 'pages'

// main
export const MainFormModalWrapper825: React.FC = () => {

    const dispatch = useDispatch()
    const reduxModalSite = useSelector((state: defaultReduxState) => state.reduxModalSite)

    const contentType = reduxModalSite.mainForm.contentType
    const contentTypeSettings = reduxModalSite.mainForm.contentTypeSettings
    const cssClass = reduxModalSite.mainForm.cssClass
    const defaultFields = reduxModalSite.mainForm.defaultFields
    const isOpen = reduxModalSite.mainForm.isOpen
    const objectId = reduxModalSite.mainForm.objectId
    const onRefresh = reduxModalSite.mainForm.onRefresh
    const profileObject = reduxModalSite.mainForm.profileObject
    const setDeleted = reduxModalSite.mainForm.setDeleted

    return (
        <Dialog
            className={`mo-dialog-class ${cssClass}`}
            classes={{ paper: 'mo-dialog-wrapper wrapper' }}
            disableEnforceFocus
            maxWidth='xl'
            onClose={() => dispatch(reduxModalMainFormHideSite())}
            open={isOpen}
        >
            <FormModal825
                contentType={contentType!}
                contentTypeSettingsN={contentTypeSettings}
                defaultFields={defaultFields}
                // @ts-ignore
                objectId={objectId}
                onRefresh={onRefresh}
                profileObject={profileObject}
                setDeleted={setDeleted}
            />
        </Dialog>
    )
}
